import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { validateEmail } from '../../custom_validators/registration.validator';
import { ValidationsService } from '../../services/common/validations.service';
import { PreloginService } from '../../services/prelogin.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-registration',
  templateUrl: './partner-registration.component.html',
  styleUrls: ['./partner-registration.component.scss']
})
export class PartnerRegistrationComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private router: Router, private validationService: ValidationsService, private preLoginService: PreloginService) { }

  // flags
  isStepOneCompleted = false;
  isLoading = false;

  isEmailAlreadyUsed = false;
  isErroredOut = false;

  isDomainAlreadyUsed = true;
  domainAlreadyUsedMessage = '';

  isLargeImage = false;
  isImageUploaded = false;
  uploadedImageName = "";

  url: any;

  // password toggle
  isFieldTypeText = false;

  // flag is set to true on button click, and is does not indicates that form has been submitted 
  isStepOneFormSubmitted = false;
  isStepTwoFormSubmitted = false;
  // flags end

  // Forms
  signUpForm_StepOne: FormGroup;
  signUpForm_StepTwo: FormGroup;

  color_1: string;
  color_2: string;

  ngOnInit() {

    // redirect already logged in user to dashboard
    if (localStorage.getItem('pp_session') != null) {
      this.router.navigate(['/my-dashboard']);
    }

    this.color_1 = '#007fb6';
    this.color_2 = '#ea6915';
    // Scenario handled - If on Step 2 and refreshes page
    // TODO - What if user wants to go back?
    if (localStorage.getItem("stepOne") != null) {
      this.isStepOneCompleted = true;
    }

    this.signUpForm_StepOne = this.formBuilder.group({
      step: ['1'],
      name: ['', Validators.required],
      mobile: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('[1-9][0-9]{9}')]],
      // email: ['', [Validators.required, Validators.email, validateEmail]],
      email: ['', [Validators.required, this.validationService.validateEmail]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      orgnization: ['']
    });

    this.signUpForm_StepTwo = this.formBuilder.group({
      step: ['2'],
      email: [''],
      domain_name: ['', [Validators.required]],
      image: [''],  // TODO - Is it a mandatory field?
      primary_color: ['#007fb6'],
      secondary_color: ['#ea6915']
    });

    // this.signUpForm_StepTwo.get('image').valueChanges.subscribe(val => {
    //   console.log(val);
    // });
  }

  // getters 
  // Sign up Step 1
  get name() { return this.signUpForm_StepOne.get('name'); }
  get email() { return this.signUpForm_StepOne.get('email'); }
  get mobile() { return this.signUpForm_StepOne.get('mobile'); }
  get password() { return this.signUpForm_StepOne.get('password'); }

  // Sign up Step 1
  get domain_name() { return this.signUpForm_StepTwo.get('domain_name'); }
  get image() { return this.signUpForm_StepTwo.get('image'); }

  togglePasswordFieldType() {
    this.isFieldTypeText = !this.isFieldTypeText;
  }

  // Step 1 submit
  signUpForm_StepOneSubmit() {

    this.isStepOneFormSubmitted = true;

    if (this.signUpForm_StepOne.invalid) {
      return;
    }
    // JSON.stringify(this.signUpForm_StepOne.value)
    this.preLoginService.registerPartner_Step1(this.signUpForm_StepOne.value).subscribe(data => {
      if (data.statusCode == 200 && data.status == false) {
        this.isEmailAlreadyUsed = data.message;
      }
      else if (data.statusCode == 500 && data.status == false) {
        this.isErroredOut = data.message;
      }
      else {
        this.isStepOneCompleted = true;
        localStorage.setItem("stepOne", JSON.stringify(this.signUpForm_StepOne.value));
      }

    });
  }

  isDomainAvailable(event) {
    if (this.domain_name.value.length > 0) {

      let postData = { "domain_name": this.domain_name.value }

      this.preLoginService.isDomainAvailable(postData).subscribe(data => {
        console.log(data);
        if (data.statusCode == 500 && data.status == false) {
          this.isErroredOut = data.message;
        }
        else {
          this.isDomainAlreadyUsed = data.available;
          this.domainAlreadyUsedMessage = data.message;
        }
      });
    }
  }

  uploadImage(event) {

    if (event.target.files[0].size > 500000) {
      this.isLargeImage = true;
    }
    else {
      this.isLargeImage = false;
      let userEmail = JSON.parse(localStorage.getItem('stepOne')).email;

      const uploadData = new FormData();
      uploadData.append('image', event.target.files[0]);
      uploadData.append('email', userEmail);

      this.preLoginService.uploadImage(uploadData).subscribe(data => {
        this.isImageUploaded = true;
        this.uploadedImageName = data.name;
        this.signUpForm_StepTwo.patchValue({
          image: this.uploadedImageName
        })
      });
    }
  }

  removeImage() {
    let userEmail = JSON.parse(localStorage.getItem('stepOne')).email;

    let postData = {
      email: userEmail
    }

    this.preLoginService.removeImage(postData).subscribe(data => {
      this.isImageUploaded = false;
      this.signUpForm_StepTwo.patchValue({
        image: ['']
      });

    });
  }

  // Step 2 submit
  signUpForm_StepTwoSubmit() {
    this.isStepTwoFormSubmitted = true;

    if (this.signUpForm_StepTwo.invalid) {
      return;
    }
    if (!this.isDomainAlreadyUsed) {
      return;
    }
    if (this.isLargeImage) {
      return;
    }

    this.signUpForm_StepTwo.patchValue({
      primary_color: this.color_1,
      secondary_color: this.color_2,
      email: JSON.parse(localStorage.getItem('stepOne')).email
    });

    this.preLoginService.registerPartner_Step2(this.signUpForm_StepTwo.value).subscribe(data => {
      if (data.statusCode == 500 && data.status == false) {
        this.isErroredOut = data.message;
      }
      else {
        this.isLoading = true;

        // auto login upon registration
        const loginData = {
          email: JSON.parse(localStorage.getItem('stepOne')).email,
          password: JSON.parse(localStorage.getItem('stepOne')).password
        };

        this.preLoginService.login(loginData).subscribe(data => {
          if (data.statusCode == 500 && data.status == false) {
            this.isErroredOut = data.message;
          }
          else {
            localStorage.removeItem('stepOne');
            this.router.navigate(['/my-dashboard']);
          }
        });
      }
    });
  }

  // phone no.
  onlyNumericInput(event) {
    return this.validationService.isNumericInput(event);
  }
}